var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sla-dashboard" }, [
    _c("section", { staticClass: "page-head" }, [
      _c("div", { staticClass: "title-wrap" }, [
        _c("div", { staticClass: "page-icon" }, [_vm._v("◴")]),
        _vm._m(0),
        _c("div", { staticClass: "update" }, [
          _c("b", [_vm._v(_vm._s(_vm.$t("collectionCenter.hubVal2")))]),
          _vm._v(_vm._s(_vm.updateTime) + " "),
        ]),
      ]),
      _c("div", { staticClass: "filters" }, [
        _c(
          "div",
          { staticClass: "filter" },
          [
            _vm._m(1),
            _c(
              "el-select",
              {
                staticClass: "filter-select",
                attrs: {
                  placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                  clearable: "",
                  size: "small",
                },
                on: { change: _vm.onWeekChange },
                model: {
                  value: _vm.filters.week,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "week", $$v)
                  },
                  expression: "filters.week",
                },
              },
              _vm._l(_vm.weekOptions, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "filter" },
          [
            _vm._m(2),
            _c(
              "el-select",
              {
                staticClass: "filter-select",
                staticStyle: { width: "100%" },
                attrs: {
                  placeholder: _vm.$t("collectionCenter.pleaseChoose"),
                  "remote-method": _vm.getCustomerPage,
                  clearable: "",
                  filterable: "",
                  remote: "",
                  "reserve-keyword": "",
                  size: "small",
                },
                on: {
                  clear: function ($event) {
                    return _vm.getCustomerPage("")
                  },
                },
                model: {
                  value: _vm.filters.customerId,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "customerId", $$v)
                  },
                  expression: "filters.customerId",
                },
              },
              _vm._l(_vm.customerNameList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.username, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "filter" },
          [
            _vm._m(3),
            _c(
              "el-select",
              {
                staticClass: "filter-select",
                staticStyle: { width: "100%" },
                attrs: {
                  placeholder: _vm.$t("collectionCenter.pleaseChoose"),
                  "remote-method": _vm.getMerchantList,
                  clearable: "",
                  filterable: "",
                  remote: "",
                  "reserve-keyword": "",
                  size: "small",
                },
                on: {
                  clear: function ($event) {
                    return _vm.getMerchantList("")
                  },
                },
                model: {
                  value: _vm.filters.merchantCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "merchantCode", $$v)
                  },
                  expression: "filters.merchantCode",
                },
              },
              _vm._l(_vm.merchantList, function (item) {
                return _c("el-option", {
                  key: item.merchantCode,
                  attrs: { label: item.merchantName, value: item.merchantCode },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "filter filter--date" },
          [
            _vm._m(4),
            _c("el-date-picker", {
              staticClass: "filter-select",
              attrs: {
                clearable: true,
                "default-time": ["00:00:00", "23:59:59"],
                format: _vm.$i18n.locale == "zh" ? _vm.zhDate : _vm.ptDate,
                placeholder: _vm.$t("newOrder.SelectDatetime"),
                "range-separator": "~",
                size: "small",
                type: "datetimerange",
                "value-format": "yyyy-MM-dd HH:mm:ss",
              },
              on: { change: _vm.onTimeChange },
              model: {
                value: _vm.timeValue,
                callback: function ($$v) {
                  _vm.timeValue = $$v
                },
                expression: "timeValue",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "filter" },
          [
            _vm._m(5),
            _c(
              "el-select",
              {
                staticClass: "filter-select",
                attrs: { size: "small" },
                model: {
                  value: _vm.filters.cargoType,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "cargoType", $$v)
                  },
                  expression: "filters.cargoType",
                },
              },
              [
                _c("el-option", {
                  attrs: { label: _vm.$t("GlobalSetObj.all"), value: null },
                }),
                _c("el-option", {
                  attrs: { label: _vm.$t("WorkCentreTable.normal"), value: 0 },
                }),
                _c("el-option", {
                  attrs: { label: _vm.$t("GlobalSetObj.big01"), value: 1 },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "filter-actions" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: { click: _vm.fetchSlaDashboard },
              },
              [_vm._v(_vm._s(_vm.$t("collectionCenter.search")) + " ")]
            ),
          ],
          1
        ),
      ]),
    ]),
    _c(
      "section",
      { staticClass: "kpi-grid" },
      _vm._l(_vm.kpiData, function (item, idx) {
        return _c("div", { key: idx, staticClass: "kpi", class: item.type }, [
          _c("div", { staticClass: "kpi-top" }, [
            _c("div", { staticClass: "kpi-icon" }, [_vm._v(_vm._s(item.icon))]),
            _c("div", { staticClass: "kpi-value" }, [
              _vm._v(_vm._s(item.value)),
            ]),
          ]),
          _c("div", { staticClass: "kpi-label" }, [
            _c("span", { staticClass: "kpi-cn" }, [
              _vm._v(_vm._s(item.labelCn)),
            ]),
            _c("span", { staticClass: "kpi-pt" }, [
              _vm._v(_vm._s(item.labelPt)),
            ]),
          ]),
          item.extra ? _c("small", [_vm._v(_vm._s(item.extra))]) : _vm._e(),
        ])
      }),
      0
    ),
    _c("section", { staticClass: "content-grid" }, [
      _c("article", { staticClass: "card" }, [
        _vm._m(6),
        _c(
          "div",
          { staticClass: "table-wrap" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  "cell-style": _vm.cellStyle,
                  data: _vm.tableData,
                  "header-cell-style": _vm.headerCellStyle,
                  "row-class-name": _vm.tableRowClassName,
                  border: "",
                  size: "mini",
                },
              },
              [
                _c(
                  "el-table-column",
                  {
                    attrs: { "min-width": "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.isGroup
                              ? _c("span", { staticClass: "group-cell" }, [
                                  _c(
                                    "i",
                                    {
                                      staticClass: "toggle",
                                      class: { collapsed: !row.expanded },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleExpand(row)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(row.expanded ? "−" : "+"))]
                                  ),
                                  _vm._v(" " + _vm._s(row.name) + " "),
                                ])
                              : row.isTotal
                              ? _c("span", { staticClass: "total-cell" }, [
                                  _vm._v(_vm._s(row.name)),
                                ])
                              : _c("span", { staticClass: "state-cell" }, [
                                  _vm._v(_vm._s(row.name)),
                                ]),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "th-cn" }, [
                        _vm._v("大区 / 州"),
                      ]),
                      _c("span", { staticClass: "th-pt" }, [
                        _vm._v("REGIÃO / ESTADO"),
                      ]),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { align: "right", "min-width": "110" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(" " + _vm._s(_vm.formatNumber(row.p)) + " "),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "th-cn" }, [
                        _vm._v("应送达包裹量"),
                      ]),
                      _c("span", { staticClass: "th-pt" }, [
                        _vm._v("TOTAL DE PACOTES"),
                      ]),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { align: "right", "min-width": "110" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(" " + _vm._s(_vm.formatNumber(row.d)) + " "),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "th-cn" }, [
                        _vm._v("已签收包裹量"),
                      ]),
                      _c("span", { staticClass: "th-pt" }, [
                        _vm._v("TOTAL DE ENTREGA"),
                      ]),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { align: "right", "min-width": "90" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", { class: _vm.rateClass(row.dr) }, [
                              _vm._v(_vm._s(_vm.formatPercentage(row.dr))),
                            ]),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "th-cn" }, [_vm._v("签收率")]),
                      _c("span", { staticClass: "th-pt" }, [
                        _vm._v("TAXA DE ENTREGA"),
                      ]),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { align: "right", "min-width": "110" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " + _vm._s(_vm.formatNumber(row.on)) + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "th-cn" }, [
                        _vm._v("准时签收量"),
                      ]),
                      _c("span", { staticClass: "th-pt" }, [
                        _vm._v("NO PRAZO"),
                      ]),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { align: "right", "min-width": "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", { class: _vm.rateClass(row.sla) }, [
                              _vm._v(_vm._s(_vm.formatPercentage(row.sla))),
                            ]),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "th-cn" }, [
                        _vm._v("SLA 准时率"),
                      ]),
                      _c("span", { staticClass: "th-pt" }, [
                        _vm._v("TAXA SLA"),
                      ]),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { align: "right", "min-width": "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " + _vm._s(_vm.formatNumber(row.late)) + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "th-cn" }, [
                        _vm._v("超时效量"),
                      ]),
                      _c("span", { staticClass: "th-pt" }, [
                        _vm._v("FORA DO PRAZO"),
                      ]),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { align: "right", "min-width": "90" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(" " + _vm._s(_vm.formatNumber(row.b)) + " "),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "th-cn" }, [
                        _vm._v("未签收量"),
                      ]),
                      _c("span", { staticClass: "th-pt" }, [_vm._v("BACKLOG")]),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { align: "right", "min-width": "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "span",
                              { class: { bad: _vm.backlogRateHigh(row.br) } },
                              [_vm._v(_vm._s(_vm.formatPercentage(row.br)))]
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("span", { staticClass: "th-cn" }, [_vm._v("积压率")]),
                      _c("span", { staticClass: "th-pt" }, [
                        _vm._v("TAXA DE BACKLOG"),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("aside", { staticClass: "side-stack" }, [
        _c("article", { staticClass: "card" }, [
          _vm._m(7),
          _c(
            "div",
            { staticClass: "ranking" },
            [
              _vm._l(_vm.deliveryRank, function (item, idx) {
                return _c(
                  "div",
                  { key: "dr-" + idx, staticClass: "rank-row" },
                  [
                    _c(
                      "div",
                      { staticClass: "rank-name", attrs: { title: item.name } },
                      [_vm._v(_vm._s(item.name))]
                    ),
                    _c("el-progress", {
                      staticClass: "rank-progress",
                      attrs: {
                        color: _vm.getProgressColor(item.value, "delivery"),
                        percentage: item.value,
                        "show-text": false,
                        "stroke-width": 16,
                      },
                    }),
                    _c("div", { staticClass: "rank-value" }, [
                      _vm._v(_vm._s(_vm.formatPercentage(item.value))),
                    ]),
                  ],
                  1
                )
              }),
              _c("div", { staticClass: "chart-note" }, [
                _vm._v(_vm._s(_vm.$t("customerManagements.higherIsBetter"))),
              ]),
            ],
            2
          ),
        ]),
        _c("article", { staticClass: "card" }, [
          _vm._m(8),
          _c(
            "div",
            { staticClass: "ranking" },
            [
              _vm._l(_vm.slaRank, function (item, idx) {
                return _c(
                  "div",
                  { key: "sr-" + idx, staticClass: "rank-row" },
                  [
                    _c(
                      "div",
                      { staticClass: "rank-name", attrs: { title: item.name } },
                      [_vm._v(_vm._s(item.name))]
                    ),
                    _c("el-progress", {
                      staticClass: "rank-progress",
                      attrs: {
                        color: _vm.getProgressColor(item.value, "sla"),
                        percentage: item.value,
                        "show-text": false,
                        "stroke-width": 16,
                      },
                    }),
                    _c("div", { staticClass: "rank-value" }, [
                      _vm._v(_vm._s(_vm.formatPercentage(item.value))),
                    ]),
                  ],
                  1
                )
              }),
              _c("div", { staticClass: "chart-note" }, [
                _vm._v(_vm._s(_vm.$t("customerManagements.higherIsBetter"))),
              ]),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "page-title" }, [
        _vm._v("SLA Diário | SLA时效看板"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", { staticClass: "label-cn" }, [_vm._v("应交付周")]),
      _c("span", { staticClass: "label-pt" }, [_vm._v("Semana de entrega")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", { staticClass: "label-cn" }, [_vm._v("客户名称")]),
      _c("span", { staticClass: "label-pt" }, [_vm._v("Nome do cliente")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", { staticClass: "label-cn" }, [_vm._v("商户名称")]),
      _c("span", { staticClass: "label-pt" }, [_vm._v("Nome do comerciante")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", { staticClass: "label-cn" }, [_vm._v("理应送达时间")]),
      _c("span", { staticClass: "label-pt" }, [
        _vm._v("Horário previsto de entrega"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", { staticClass: "label-cn" }, [_vm._v("货物类型")]),
      _c("span", { staticClass: "label-pt" }, [_vm._v("Tipo de mercadorias")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-head" }, [
      _c("span", { staticClass: "card-title" }, [
        _vm._v("SLA Diário | SLA时效看板"),
      ]),
      _c("span", { staticClass: "card-meta" }, [
        _vm._v("按大区 / 州展开 Expandir por Região / Estado"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-head" }, [
      _c("span", { staticClass: "card-title" }, [_vm._v("各大区签收率")]),
      _c("span", { staticClass: "card-meta" }, [
        _vm._v("Taxa de assinatura por região"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-head" }, [
      _c("span", { staticClass: "card-title" }, [_vm._v("各大区准时签收率")]),
      _c("span", { staticClass: "card-meta" }, [
        _vm._v("Taxa SLA no prazo por região"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }